var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-error"},[_c('img',{staticClass:"layout-error__image",attrs:{"src":require("../../../../public/img/error.png"),"alt":"lock"}}),_c('div',{staticClass:"layout-error__message"},[_vm._v(_vm._s(_vm.errorMessage))])])}
var staticRenderFns = []

export { render, staticRenderFns }